// Conversion entre les deux référentiels carburant : FUEL_TYPES (id numérique,
// porté par les véhicules) et FLOTTE.CARBURANTS (clé string, attendue par
// l'API flotte / simulateur de grille VR). Le `name` est le pivot commun.
const carburantTools = {
  fuelTypeIdToCarburantId: (fuelTypeId, fuelTypes, carburants) => {
    if (!fuelTypeId || !fuelTypes || !carburants) return null;
    const ft = fuelTypes.find((f) => String(f.id) === String(fuelTypeId));
    if (!ft) return null;
    const carb = carburants.find((c) => c.name === ft.name);
    return carb ? carb.id : null;
  },
};

export default carburantTools;
